import { message } from "antd";
// import {getRefreshToken} from '../services/loginServices';
// import { clearSession, setAuthLoading, setErrorAuth, setPostLoading, setSkeletonLoading } from '../store/reducers/authentication.reducer';
// import { setTableLoading } from '../store/reducers/page.reducer';

// export const ResetLoader = (dispatch) => {
//   dispatch(setPostLoading(false))
//   dispatch(setAuthLoading(false))
//   dispatch(setTableLoading(false))
//   dispatch(setSkeletonLoading(false))
// }

// export const ErrorHandler = async (error, dispatch) => {
//   ResetLoader(dispatch)
//   message.config({ maxCount: 1 })

//   if (error.response.status === 502) {
//     // error.response.data.nexsoft.payload.status.message &&
//     //   message.error(error.response.data.nexsoft.payload.status.message)
//   } else if (error.response.status === 401) {
//     dispatch(clearSession())
//     dispatch(setErrorAuth('Wrong Username or Password, Please Check Again'))
//   } else if (error.response.status === 400) {
//     // error.response.data.nexsoft.payload.status.message &&
//     //   message.error(error.response.data.nexsoft.payload.status.message)
//   }
// }

export const checkValidationToken = async (error, token, refresh_token, dispatch) => {
  message.config({ maxCount: 1 });

  if (error.response.status === 502) {
    // error.response.data.nexsoft.payload.status.message &&
    //   message.error(error.response.data.nexsoft.payload.status.message)
  } else if(error.response.status === 401){
    if(token) {
      // await getRefreshToken(token, refresh_token, dispatch)
      console.log('error 401, get refresh_token')
    } else {
      // ErrorHandler(error, dispatch)
      console.log('error 401, token tidak ada')
    }
  } else if(error.response.status === 400){
    // error.response.data.nexsoft.payload.status.message &&
    //   message.error(error.response.data.nexsoft.payload.status.message)
  }
}